import DOMPurify from 'dompurify';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import CloseSVG from '../../../../assets/svg/close.svg';
import { formValidation } from '../../../../utils/functions';
import Button from '../../../button';
import FormInput from '../../../form-input';
import {
  useCreateSingleVendor,
  useUpdateVendor,
} from '../../../../redux/spend-management/vendor/hook';
import FormSelect from '../../../form-select';
import {
  useGetBanks,
  useResolveBankAccount,
} from '../../../../redux/bank/hook';
import FormDatalist from '../../../form-datalist';
import FormSwitch from '../../../form-switch';
import Modal from '../../modal';
import {
  countriesAndState,
  AllCountries,
} from '../../../../constants/countries';

function AddVendor({
  isOpen,
  closeModal,
  refresh,
  vendorData,
  title,
  buttonText,
  completed,
}) {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  });

  const { mutateAsync: addVendor, isLoading: addVendorloading } =
    useCreateSingleVendor();
  const { mutateAsync: editVendor, isLoading: editVendorloading } =
    useUpdateVendor();

  const [country, setCountry] = useState('Nigeria');
  const [state, setState] = useState('Lagos');
  const [stateOptions, setStateOptions] = useState([]);
  const [vendor, setVendor] = useState();

  const [vendorName, setVendorName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [city, setCity] = useState('');
  const [status, setStatus] = useState(true);

  const [bankname, setBankName] = useState('');
  const [account_number, setAccountNumber] = useState('');
  const [account_name, setAccountName] = useState('');
  const [vendorType, setVendorType] = useState();

  const { mutateAsync: resolveAccount, isLoading: resolveAccountLoading } =
    useResolveBankAccount();
  const { data: banks } = useGetBanks();

  useEffect(() => {
    if (vendorData) {
      setVendor(vendorData.id);
      setVendorName(vendorData.vendor_name || '');
      setContactPerson(vendorData.contact_person || '');
      setMobile(vendorData.mobile || '');
      setEmail(vendorData.email || '');
      setStreetAddress(vendorData.street_address || '');
      setCity(vendorData.city || '');
      setCountry(vendorData.country || 'Nigeria');
      setState(vendorData.state || 'Lagos');
      setStatus(vendorData.status === 1);
      setBankName(vendorData.bank || '');
      setAccountNumber(vendorData.account_number || '');
      setAccountName(vendorData.account_name || '');
      setVendorType('edit');
    } else {
      setVendorType('add');
    }
  }, [vendorData]);

  useEffect(() => {
    if (account_number.length === 10 && bankname !== '') {
      let payload = {
        bankname,
        account_number,
      };
      setAccountName('');
      resolveAccount(payload)
        .then((response) => {
          setAccountName(response.data.accountname);
        })
        .catch(() => {
          setAccountName('Not Resolved');
        });
    }
  }, [account_number, bankname]);

  useEffect(() => {
    if (country) {
      let getStates = countriesAndState.find((a) => a.name === country);

      if (getStates) {
        let computedStates = [];

        getStates.states.map((item) => {
          computedStates.push({ label: item, value: item });
        });

        setStateOptions(computedStates);
      }
    }
  }, [country]);

  const submitForm = async (data) => {
    if (vendorType === 'add') {
      let payload = {
        vendor_name: DOMPurify.sanitize(vendorName),
        contact_person: DOMPurify.sanitize(contactPerson),
        mobile: DOMPurify.sanitize(mobile),
        email: DOMPurify.sanitize(email),
        street_address: DOMPurify.sanitize(streetAddress),
        city: DOMPurify.sanitize(city),
        state,
        country,
        bank: bankname,
        account_number: DOMPurify.sanitize(account_number),
        account_name: DOMPurify.sanitize(account_name),
        status: 1,
      };
      await addVendor(payload).then(() => {
        completed();
      });
    } else if (vendorType === 'edit') {
      let editPayload = {
        vendorId: vendor,
        data: {
          vendor_name: DOMPurify.sanitize(vendorName),
          contact_person: DOMPurify.sanitize(contactPerson),
          mobile: DOMPurify.sanitize(mobile),
          email: DOMPurify.sanitize(email),
          street_address: DOMPurify.sanitize(streetAddress),
          city: DOMPurify.sanitize(city),
          state,
          country,
          bank: bankname,
          account_number: DOMPurify.sanitize(account_number),
          account_name: DOMPurify.sanitize(account_name),
          status: status ? 1 : 0,
        },
      };
      await editVendor(editPayload).then(() => {
        completed();
      });
    }
  };

  return (
    <Modal
      scrollable={true}
      className='!max-w-[600px] !min-w-[600px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <form className='form pb-4' onSubmit={handleSubmit(submitForm)}>
          <div className='px-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>{title}</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col mx-8'>
            <div className='flex flex-col md:flex-row w-full justify-between'>
              <div className='w-full md:w-1/2 md:pr-2'>
                <FormInput
                  label='Vendor Name'
                  name='vendor_name'
                  type='text'
                  placeholder={'Enter vendor name'}
                  value={vendorName}
                  onChange={(e) => setVendorName(e.target.value)}
                  inputRef={register(formValidation('text', true))}
                  readOnly={addVendorloading || editVendorloading}
                  error={errors.vendor_name}
                  errorMessage={
                    errors.vendor_name && errors.vendor_name.message
                  }
                />
              </div>

              <div className='w-full md:w-1/2 md:pl-2'>
                <FormInput
                  label='Contact Person'
                  name='contact_person'
                  type='text'
                  placeholder={'Enter contact person'}
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  inputRef={register(formValidation('text', true))}
                  readOnly={addVendorloading || editVendorloading}
                  error={errors.contact_person}
                  errorMessage={
                    errors.contact_person && errors.contact_person.message
                  }
                />
              </div>
            </div>
            <div>
              <div className='flex flex-col md:flex-row w-full justify-between'>
                <div className='w-full md:w-3/5 md:pr-2'>
                  <FormInput
                    label='Email'
                    name='email'
                    type='email'
                    placeholder={'Enter vendor email'}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    inputRef={register(formValidation('email', true))}
                    readOnly={addVendorloading || editVendorloading}
                    error={errors.email}
                    errorMessage={errors.email && errors.email.message}
                  />
                </div>

                <div className='w-full md:w-2/5 md:pl-2'>
                  <FormInput
                    label='Mobile'
                    name='mobile'
                    type='text'
                    placeholder={'Enter vendor mobile'}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    inputRef={register(formValidation('text', true))}
                    readOnly={addVendorloading || editVendorloading}
                    error={errors.mobile}
                    errorMessage={errors.mobile && errors.mobile.message}
                  />
                </div>
              </div>
              <div className='flex flex-col md:flex-row w-full justify-between'>
                <div className='w-full md:w-1/2 md:pr-2'>
                  <FormSelect
                    value={country}
                    options={AllCountries}
                    onChange={(selected) => {
                      setCountry(selected);
                    }}
                    label='Country'
                  />
                </div>

                <div className='w-full md:w-1/2 md:pl-2'>
                  {country == 'Nigeria' ? (
                    <FormSelect
                      value={state}
                      options={stateOptions}
                      onChange={(selected) => {
                        setState(selected);
                      }}
                      label='State'
                    />
                  ) : (
                    <FormInput
                      label='State'
                      name='state'
                      type='text'
                      placeholder={'Enter vendor state'}
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      error={errors.state}
                      errorMessage={errors.state && errors.state.message}
                    />
                  )}
                </div>
              </div>

              <div className='flex flex-col md:flex-row justify-between'>
                <div className='w-full md:w-2/5 md:pr-2'>
                  <FormInput
                    label='City'
                    name='city'
                    type='text'
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder={'Enter vendor city'}
                    inputRef={register(formValidation('text', true))}
                    readOnly={addVendorloading || editVendorloading}
                    error={errors.city}
                    errorMessage={errors.city && errors.city.message}
                  />
                </div>
                <div className='w-full md:w-3/5 md:pl-2'>
                  <FormInput
                    label='Street Address'
                    name='address'
                    type='text'
                    placeholder={'Enter vendor address'}
                    value={streetAddress}
                    onChange={(e) => setStreetAddress(e.target.value)}
                    inputRef={register(formValidation('text', false))}
                    readOnly={addVendorloading || editVendorloading}
                    error={errors.address}
                    errorMessage={errors.address && errors.address.message}
                  />
                </div>
              </div>

              <hr className='divider' />
              <div className='flex flex-col md:flex-row w-full justify-between'>
                <div className='w-full md:w-3/5'>
                  <FormDatalist
                    label='Bank Name'
                    data={banks ? banks : []}
                    value={bankname}
                    onSelect={(value) => {
                      setAccountNumber('');
                      setBankName(value);
                    }}
                  />
                </div>

                <div className='w-full md:w-2/5 pl-2'>
                  <FormInput
                    label='Bank Account Number'
                    name='account_number'
                    type='text'
                    placeholder={'Enter account number'}
                    value={account_number}
                    inputRef={register(formValidation('text', true))}
                    error={errors.account_number}
                    errorMessage={
                      errors.account_number && errors.account_number.message
                    }
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
              </div>
              <FormInput
                label='Bank Account Name (Auto-Generated)'
                name='account_name'
                type='text'
                placeholder={
                  resolveAccountLoading
                    ? 'Fetching Account Name ....'
                    : 'This field is auto-generated'
                }
                readOnly
                inputRef={register(formValidation('text', true))}
                value={account_name}
                error={errors.account_name}
                errorMessage={
                  errors.account_name && errors.account_name.message
                }
              />
              {vendorType === 'edit' ? (
                <FormSwitch
                  label={'Status'}
                  name={'status'}
                  readOnly={addVendorloading || editVendorloading}
                  checked={status}
                  onClick={() => {
                    setStatus(!status);
                  }}
                  value={status}
                />
              ) : null}
            </div>

            <div className='w-full mt-[20px]'>
              <Button
                text={buttonText}
                type='submit'
                disabled={false}
                loading={addVendorloading || editVendorloading}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default AddVendor;
